import React from 'react';
import * as UI from '../constantes/UI.js';
import styles from './BotoneraFiltros.module.css';

const BotoneraFiltros = (props) => {
  const filtros = props.filtros;
  const selected = props.selected;
  const { esMobile } = UI.useUI();

  const FiltroHandler = (event) => {
    // Si el valor es string vacío (null), pasar null; de lo contrario, pasar el valor tal cual
    const valor = event.target.value === '' ? null : event.target.value;
    props.onFiltroElegido(valor);
    // Al cambiar el filtro, volver a la primera página (0)
    if (typeof props.onResetPagina === 'function') {
      props.onResetPagina(0);
    }
  };

  if (!filtros) return null;

  // En mobile, mostrar un select más compacto
  if (esMobile && filtros.length > 4) {
    return (
      <div className={`${styles.cuadroFiltros}`}>
        <select
          value={selected === null ? '' : selected}
          onChange={FiltroHandler}
          className={`${styles.selectFiltros}`}
        >
          {filtros.map((filtro) => (
            <option
              key={filtro.codigo === null ? 'null' : filtro.codigo}
              value={filtro.codigo === null ? '' : filtro.codigo}
            >
              {filtro.descripcion}
            </option>
          ))}
        </select>
      </div>
    );
  }

  // En desktop o si hay pocos filtros, mantener los botones
  return (
    <React.Fragment>
      {filtros.length > 0 && (
        <div className={`${styles.cuadroFiltros}`}>
          {filtros.map((filtro) => (
            <label
              key={filtro.codigo}
              className={`${styles.filtro} ${filtro.codigo === selected ? styles.selected : ''}`}
              title={filtro.descripcion}
            >
              <input
                type="radio"
                value={filtro.codigo}
                checked={filtro.codigo === selected}
                onChange={FiltroHandler}
                aria-label={filtro.descripcion}
              />
              {filtro.descripcion}
            </label>
          ))}
        </div>
      )}
    </React.Fragment>
  );
};

export default BotoneraFiltros;
